import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import {
  useSalesWeeklyQuery,
  useSaleTotalQuery,
} from "../../../../services/saleApi";
import {
  useTodayGrnsQuery,
  useWeeklyGrnsQuery,
} from "../../../../services/grnApi";
import { startOfToday, endOfToday, format, formatDistance } from "date-fns";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const PieChart = ({ sale, cogs, lossProfit }) => {
  // Calculate percentages
  const total = sale + cogs + lossProfit;
  const salePercentage = ((sale / total) * 100).toFixed(1) || 0;
  const cogsPercentage = ((cogs / total) * 100).toFixed(1) || 0;
  const profitPercentage = ((lossProfit / total) * 100).toFixed(1) || 0;

  const data = {
    labels: [
      `Sales (${salePercentage || 0}%)`,
      `COGS (${cogsPercentage || 0}%)`,
      `Profit (${profitPercentage || 0}%)`
    ],
    datasets: [
      {
        data: [sale, cogs, lossProfit],
        backgroundColor: [
          "rgba(54, 162, 235, 0.8)",  // Blue for Sales
          "rgba(237, 56, 51, 0.8)",   // Red for COGS
          "rgba(75, 192, 192, 0.8)"   // Teal for Profit
        ],
        borderColor: [
          "rgb(54, 162, 235)",
          "rgb(237, 56, 51)",
          "rgb(75, 192, 192)"
        ],
        borderWidth: 1,
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          font: {
            size: 12,
            weight: '500'
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const formattedValue = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'BDT',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
            return `${label}: ${formattedValue}`;
          }
        }
      }
    },
    cutout: '60%',
    animation: {
      animateScale: true,
      animateRotate: true
    }
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ height: '200px', width: '100%', position: 'relative' }}>
        <Doughnut data={data || 0} options={options} />
      </div>
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <div style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000000' }}>
          Total: {new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'BDT',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(lossProfit)}
        </div>
      </div>
    </div>
  );
};

export default PieChart;
